<template>
  <div class="pageContent-in">
    <div class="pageContent-main">
      <div class="documentation__searchTab">
        <h1>CAD výkresy - výsledky hledání “{{q}}”</h1>
        <download-search-input/>
        <div class="documentation__searchTab--constructionList" v-if="documents.length">
          <cad-construction-list :documents="documents"/>
        </div>
        <div v-if="0 === documents.length && false === processing && init" class="notFound">
          Vašemu zadání neodpovídá žádný výsledek.
        </div>
        <router-link :to="{name: 'cad.download'}">Zpět na přehled všech CAD výkresů</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import DownloadSearchInput from './SearchInput';
  import CadConstructionList from '../cad/ConstructionList';

  export default {
    name:       'DownloadSearchTab',
    components: {
      CadConstructionList,
      DownloadSearchInput
    },
    watch:      {
      '$route': function () {
        this.q = this.getSearchString();
        this.search();
      },
    },
    data() {
      return {
        q:    this.getSearchString(),
        init: false,
      }
    },
    mounted() {
      this.setDocuments([]);
      this.search().then(() => {
        this.init = true;
      });
    },
    computed:   {
      ...mapGetters('download', ['documents', 'processing']),
    },
    methods:    {
      ...mapActions('download', ['searchDocuments', 'setDocuments']),
      getSearchString() {
        return this.$route.query.q;
      },
      search() {
        return this.searchDocuments(this.getSearchString());
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cad/SearchTab.vue